import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * Streamline Engineering design system.
 *   Champagne Gold #C9A24A — primary / CTA        Deep Metallic Gold #A57C1B — hover
 *   Matte Black #1C1C1C — text / header           Rich Charcoal #2A2A2A — surfaces / nav
 *   Warm Ivory #F5F1E8 — background / containers   Soft Gray #D9D4CC — borders / dividers
 */
const gold: MantineColorsTuple = [
  '#fbf6e8',
  '#f1e6c6',
  '#e6d29c',
  '#dcbf72',
  '#d3af51',
  '#cea63f', // 5 — primary (champagne)
  '#c9a24a', // 6 — champagne gold
  '#a57c1b', // 7 — deep metallic gold (hover / strong accents)
  '#855f14',
  '#5f430c',
];

// A warm, ivory-biased neutral so greys read as chosen, not default.
const sand: MantineColorsTuple = [
  '#f7f4ee',
  '#eeeae1',
  '#ddd7ca',
  '#ccc4b2',
  '#bdb39d',
  '#b4a98f',
  '#afa386',
  '#998e72',
  '#897e64',
  '#786d54',
];

export const theme = createTheme({
  primaryColor: 'gold',
  primaryShade: { light: 6, dark: 5 },
  autoContrast: true,
  luminanceThreshold: 0.45,
  colors: { gold, sand },
  defaultRadius: 'md',
  black: '#1C1C1C',
  white: '#ffffff',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: { fontWeight: '700' },
});
